import { useQuery } from '@tanstack/react-query';
import { SystemRoleName } from '@evimo/types/enums/system-role-name';
import { useAuth } from '~/app/auth/context/AuthContext';
import type { WorkTypeResponseDto } from '@evimo/client/models';
import { PreventiveMaintenanceService } from '~/app/services/preventive-maintenance/preventive-maintenance.service';

export function useWorkTypes() {
  const { user } = useAuth();
  const isSuperAdmin = user?.roleName === SystemRoleName.SUPER_ADMIN;
  const organizationId = user?.organizationId ?? '';
  const scopeKey = isSuperAdmin ? 'all-orgs' : organizationId;

  const query = useQuery({
    queryKey: ['preventive-maintenance', 'work-types', scopeKey] as const,
    queryFn: () => PreventiveMaintenanceService.listWorkTypes(),
    select: (res): WorkTypeResponseDto[] => res.data,
    enabled: isSuperAdmin || !!organizationId,
  });

  const workTypes: WorkTypeResponseDto[] = query.data ?? [];

  return {
    data: workTypes,
    workTypes,
    isLoading: query.isLoading,
    error: (query.error ?? null) as Error | null,
  };
}
